import { writable } from 'svelte/store';

export const navStatus = writable('featured');
export const modalStatus = writable('off');
export const currentMemory = writable(null);